import { restClient } from '../../client';
import { Match, PublicUser, UserProfile } from '../../resources';


export const getProviderActivePatients = (providerId: string) =>
  restClient.request<{
    data: {
      user: PublicUser;
      profile: UserProfile;
      match: Match;
    }[];
  }>(`/api/v1/provider/${providerId}/active-patients`);
